import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import PropTypes from "prop-types";
import assetPath from "~/utils/assetPath";
import MenuContainer from "./containers/MenuContainer";
import PuzzleContainer from "./containers/PuzzleContainer";

import styles from "./Puzzles.scss";

class Puzzles extends React.Component {
  static propTypes = {
    id: PropTypes.string
  }

  //-----------------------------------------------------------------------
  // Lifecycle
  //-----------------------------------------------------------------------
  componentDidMount() {
    // Initialize perfect scrollbar
    if (is.falsy(bowser.mobile) && is.falsy(bowser.tablet)) {
      // Initialize perfect scrollbar
      $("#app").perfectScrollbar({ suppressScrollX: true });

      // Only show scroll on scroll
      let scrollTimer;
      $("#app").on("ps-scroll-y", () => {
        // Add class to scrollbar
        $(".ps__scrollbar-y-rail").addClass("scrolling");

        // Reset window resize timer
        if (is.existy(scrollTimer)) {
          clearTimeout(scrollTimer);
        }

        // Call scroll timer
        scrollTimer = _.delay(() => {
          // Remove class from scrollbar
          $(".ps__scrollbar-y-rail").removeClass("scrolling");
        }, 1280);
      });
    }

    // Load background overlay and then fade it in
    const backgroundOverlayImage = new Image();
    backgroundOverlayImage.onload = (event) => {
      $("#background_image").css("opacity", 1)
    }
    backgroundOverlayImage.src = assetPath("background_overlay", "png")
  }

  //-----------------------------------------------------------------------
  // Render
  //-----------------------------------------------------------------------
  render() {
    return (
      <div id="puzzles_route">
        <div id="puzzle_container">
          <MenuContainer
            shouldShowBackButton={true}
            isPuzzlePage={true}
            onRef={ref => {
              this.menuContainer = ref;
            }}
          />
          <PuzzleContainer id={this.props.id} />
        </div>
        <div
          id="background"
          style={{
            backgroundImage: `url('${assetPath("background_tile", "jpg")}')`
          }}
        >
          <img id="background_image" alt="Background image" src={assetPath("background_overlay", "png")} />
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Puzzles);



// WEBPACK FOOTER //
// ./src/routes/puzzles/Puzzles.js